module.exports = __webpack_public_path__ + "media/images/story/top/qa_more-c982e9ecdbeb862715c0a69f81f69355.png";